import React from 'react';

import { ReactComponent as BoletoIcon } from '../assets/boleto.svg'
import { ReactComponent as PixIcon } from '../assets/pix.svg'
import { ReactComponent as AddCardIcon } from '../assets/add_card.svg'
import { ReactComponent as CardIcon } from '../assets/card.svg'
import { ReactComponent as ErrorIcon } from '../assets/error.svg'
import { isMobile } from 'react-device-detect';
import { LoadingSpinner } from './Loading';

type ThemeKey = 'white' | 'gray' | 'lightgreen' | 'mediumgreen' | 'darkgreen' | 'lightred' | 'darkred'
type IconKey = 'boleto' | 'cartao' | 'pix' | 'cadastrar_cartao' | 'alterar_cartao'
type IconComponent = React.FC<React.SVGProps<SVGSVGElement>>

interface Props {
  children: string;
  onClick?: () => void;
  disabled?: boolean
  theme: ThemeKey;
  icon: IconKey;
  wide?: boolean;
  legend?: string;
  loading?: boolean;
  error?: string
  flat?: boolean;
}

type ThemeValues = {
  border: string,
  bg: string,
  font_color: string,
  icon_color: string,
  legend_color: string,
  hover: string
}

const ButtonMethodPayment: React.FC<Props> = ({ children, theme, icon, wide, legend, onClick, disabled, loading, error, flat }) => {

  const words = children.trim().split(' ');
  const lastWord = words.pop();
  error && (theme = 'lightred');

  const theme_model: Record<ThemeKey, ThemeValues> = {
    white: {
      border: "border-gray-primary",
      bg: "bg-white-primary",
      font_color: "text-blue-primary",
      icon_color: "blue-primary",
      legend_color: "blue-primary",
      hover: disabled ? "" : "hover:bg-gray-light"
    },
    gray: {
      border: "border-gray-primary",
      bg: "bg-gray-light",
      font_color: "text-blue-primary",
      icon_color: "blue-primary",
      legend_color: "blue-primary",
      hover: "hover:bg-gray-light"
    },
    lightgreen: {
      border: "border-green-dark",
      bg: "bg-green-light",
      font_color: "text-green-dark",
      icon_color: "white-primary",
      legend_color: "white-primary",
      hover: "hover:bg-green-medium"
    },
    mediumgreen: {
      border: "border-green-medium",
      bg: "bg-green-medium",
      font_color: "text-white-primary",
      icon_color: "white-primary",
      legend_color: "white-primary",
      hover: "hover:bg-green-dark"
    },
    darkgreen: {
      border: "border-green-dark",
      bg: "bg-green-dark",
      font_color: "text-white-primary",
      icon_color: "white-primary",
      legend_color: "white-primary",
      hover: "hover:bg-green-dark"
    },
    lightred: {
      border: "border-red-primary",
      bg: "bg-red-light",
      font_color: "text-blue-primary",
      icon_color: "blue-primary",
      legend_color: "red-primary",
      hover: "hover:bg-red-primary"
    },
    darkred: {
      border: "border-red-primary",
      bg: "bg-red-medium",
      font_color: "text-blue-primary",
      icon_color: "blue-primary",
      legend_color: "red-primary",
      hover: "hover:bg-red-dark"
    },
  }

  const icon_model: Record<IconKey, IconComponent> = {
    'boleto': BoletoIcon,
    'cartao': CardIcon,
    'pix': PixIcon,
    'cadastrar_cartao': AddCardIcon,
    'alterar_cartao': AddCardIcon,
  }
  const IconComponent = icon_model[icon]

  return (
    <button
      className={`
        px-[0.9rem]
        py-[0.75rem]
        rounded-[0.5rem]
        flex flex-col
        justify-start
        items-start
        border
        ${wide ? 'w-[100%]' : 'w-[30%]'} 
        ${theme_model[theme].border}
        ${theme_model[theme].font_color}
        ${theme_model[theme].bg}
        ${!isMobile && !wide && 'pr-[10rem]'}
        ${theme_model[theme].hover}
        ${disabled && 'opacity-[45%]'} 
     `}
      onClick={disabled ? () => { } : onClick}
    >
      <div className={`
            flex 
            !w-[100%]
            ${!wide || flat ? 'flex-col items-start' : 'flex-row items-end justify-center'}
          `}>
        {loading ?
          <LoadingSpinner /> :
          <>
            <IconComponent className={`${!wide ? 'mb-[1rem]' : 'mr-[0.5rem]'} w-[1.3rem] h-[1.3rem] ${theme_model[theme].icon_color} `} />
        <div className={flat || wide ? 'flex flex-row' : 'flex flex-col items-start'}>
          <p className='text-[0.8rem] whitespace-nowrap'>{words.join(' ')} </p>
          <strong className={!wide ? 'ml-0' : 'ml-1 text-[0.8rem]'}> {lastWord}</strong>
        </div>
          </>
        }
      </div>
      {wide && error &&
        <div className='flex flex-row items-center mt-[0.5rem]'>
          <ErrorIcon />
          <p className={`${theme_model[theme].legend_color} text-[0.8rem] text-red-primary`}>{error}</p>
        </div>
      }
    </button >
  );
}

export default ButtonMethodPayment;
